import { render, staticRenderFns } from "./pushPrize.vue?vue&type=template&id=5776639e&scoped=true"
import script from "./pushPrize.vue?vue&type=script&lang=js"
export * from "./pushPrize.vue?vue&type=script&lang=js"
import style0 from "./pushPrize.vue?vue&type=style&index=0&id=5776639e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5776639e",
  null
  
)

export default component.exports